import { cancel } from "./ExecutionStatus";
/**
 * Determines whether any of the responses from the servers contain errors so we can update
 * the Blob and DOM accordingly. Creates new response array so that the error responses will
 * float to the top for easier readability.
 *
 * @returns {boolean} indicates whether any of the responses contain an unsuccessful request.
 */
export function determineAndOrganizeErrors(responses) {
    if (cancel) {
        return;
    }
    const errorArr = [];
    const successArr = [];
    responses.forEach((response) => {
        if (cancel) {
            return;
        }
        if (isError(response.status)) {
            errorArr.push(response);
        }
        else {
            successArr.push(response);
        }
    });
    const organizedResponseArr = errorArr.concat(successArr);
    const responseSummary = {
        errorCount: errorArr.length,
        successCount: successArr.length,
        organizedResponseArr,
        containsErrors: !!errorArr.length,
    };
    return responseSummary;
}
/**
 * Determines whether a response row should have a hidden or displayed class by default and whether error details should be appended.
 * By default, errors are displayed and successes are hidden.
 * isError returns true if status code is betweeen 400 and 999 or a status 0. If true, DomHelper in self help applies an error css class to the element
 * displaying the uri being tested.
 */
export function isError(status) {
    return (status === 0) || (400 <= status && status <= 999);
}
/**
 * Returns true if status code is between 300 and 400.
 * If true, DomHelper in self help applies a warning css class to the element displaying the uri being tested.
 */
export function isWarning(status) {
    return 300 <= status && status < 400;
}
/**
 * Returns true if status code is between 200 and 300.
 * If true, DomHelper in self help applies a successful css class to the element displaying the uri being tested.
 */
export function isSuccess(status) {
    return 200 <= status && status < 300;
}
//# sourceMappingURL=ErrorHelper.js.map